module.exports = __webpack_public_path__ + "img/two-green-fire.f280652b.svg";